// extracted by mini-css-extract-plugin
module.exports = {"monthDay":"_1pwyX","weekAndMonth":"_33J-t","weekDay":"_3fxSN","month":"_2tNA-","listHeaderTitle":"_2Cofy","color":"J2pYd"};